export enum AttachmentType {
  JobPaperwork = '1',
  IncomingAssetPhotos = '2',
  OutgoingAssetPhotos = '3',
  CustomerInfo = '4'
}
